import { useRef } from 'react'

import { useFrame } from '../../../engine'
import { pv } from '../../../motion'
import { useCopy } from '../../i18n'
import { CtaPair } from '../PlayStory'
import { Mark } from '../shapes'

// Lage der vier Signet-Teile vor dem Zusammensetzen, in Einheiten des Signets (64 × 56)
const SCATTER = [
  { x: -30, y: -30, r: -18, s: 0.9, bob: 0 },
  { x: -34, y: 30, r: 28, s: 1.3, bob: 1.1 },
  { x: 34, y: -26, r: 16, s: 1.1, bob: 2.3 },
  { x: 30, y: 30, r: -30, s: 1.35, bob: 3.1 }
]

const piece = (_, i) => {
  const s = SCATTER[i]
  return {
    '--sx': s.x,
    '--sy': s.y,
    '--sr': s.r,
    '--ss': s.s,
    animationDelay: `${-s.bob}s`
  }
}

/**
 * Einstieg: Headline und CTAs, daneben schweben die vier Teile des Aivy-Signets.
 * Beim Scrollen setzen sie sich zusammen, der Schriftzug kommt dazu, danach
 * zoomt die Kamera in die blaue Fläche und das nächste Kapitel beginnt.
 */
export default function PlHero() {
  const c = useCopy('hero')
  const ui = useCopy('ui')
  const ref = useRef(null)

  // Sobald das Signet steht, schwebt nichts mehr, sonst rastert der Zoom jedes Bild neu
  useFrame((l) => {
    ref.current?.classList.toggle('is-still', l > 0.42)
  })

  return (
    <div
      ref={ref}
      className='ap-hero'
      style={{
        ...pv('o', [0.06, 0.24]),
        ...pv('g', [0.1, 0.42]),
        ...pv('c', [0.18, 0.44]),
        ...pv('w', [0.4, 0.52]),
        ...pv('v', [0.6, 0.68]),
        ...pv('z', [0.62, 0.9]),
        ...pv('f', [0.7, 0.96])
      }}
    >
      <div className='ap-hero__copy'>
        <div className='ap-eyebrow'>{c.eyebrow}</div>
        <h1 className='ap-display'>
          {c.title.map((line) => (
            <span key={line}>{line}</span>
          ))}
        </h1>
        <p className='ap-lead'>{c.sub}</p>
        <CtaPair ui={ui} size='lg' />
        <ul className='ap-hero__trust'>
          {c.trust.map((t) => (
            <li key={t}>{t}</li>
          ))}
        </ul>
      </div>

      <div className='ap-hero__stage'>
        <div className='ap-hero__lockup'>
          <Mark className='ap-hero__mark' pieceStyle={piece} />
          <div className='ap-hero__word' aria-hidden='true'>
            Aivy
          </div>
        </div>
        <div className='ap-hero__tag'>{c.tagline}</div>
      </div>

      <div className='ap-hero__flood' aria-hidden='true' />
      <div className='ap-cue'>
        <span className='ap-cue__dot' />
        {ui.cue}
      </div>
    </div>
  )
}
